'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
var dateTimeFieldContext = require('../dateTimeFieldContext.js');
var useDateSegment = require('./useDateSegment.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "segment"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * DateSegment
 *
 * Renders a single segment of a date/time field.
 *
 * A segment can be anything: Day, month, minute, second - or a
 * separator like `.` or `/`.
 *
 * The segments also represent the element where data is put in.
 */
var DateSegment = function DateSegment(props) {
  var className = props.className,
    segment = props.segment,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var ref = React.useRef();
  var styles = dateTimeFieldContext.useDateTimeFieldStyles();
  var _useDateSegment = useDateSegment.useDateSegment(segment, ref),
    getHtmlProps = _useDateSegment.getHtmlProps;
  var segmentStyles = _objectSpread(_objectSpread({}, styles.segment), {}, {
    '--segment-width': !!segment.maxValue ? "".concat(String(segment.maxValue).length, "ch") : null
  }, segment.text === ', ' ? {
    pr: 1.5
  } : null);

  // Fill up numbers with leading zeros. e.g. Month: 3 -> 03
  var textFormatted = segment.type === 'day' || segment.type === 'month' || segment.type === 'year' || segment.type === 'second' || segment.type === 'minute' || segment.type === 'hour' ? segment.text.padStart(2, '0') : segment.text;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({}, getHtmlProps(rest), {
    ref: ref,
    __css: segmentStyles,
    className: utils.cx('chakra-date-field_segment', "chakra-date-field_segment--".concat(segment.type), segment.isPlaceholder && "chakra-date-field_segment--placeholder", className)
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.span, {
    "aria-hidden": "true",
    __css: {
      display: 'block',
      width: 'full',
      textAlign: 'center'
    },
    style: {
      visibility: segment.isPlaceholder ? 'initial' : 'hidden',
      height: segment.isPlaceholder ? '' : 0,
      pointerEvents: 'none'
    }
  }, segment.placeholder), segment.isPlaceholder ? '' : textFormatted);
};
exports.DateSegment = DateSegment;